import * as yup from "yup";

const lfpSchema = yup.object().shape({
    description: yup.string().optional(),
    contactName: yup.string().optional(),
    contactEmail: yup.string().optional(),
    contactNumber: yup.string().optional(),
    contactSite: yup.string().optional(),
    positions: yup
        .array(
            yup.object().shape({
                value: yup.number().required(),
                label: yup.string().required(),
            }),
        )
        .optional(),
    ageLevels: yup
        .array(
            yup.object().shape({
                value: yup.number().required(),
                label: yup.string().required(),
            }),
        )
        .min(1, "Please select at least one age level")
        .required("Please select at least one age level"),
});

export default lfpSchema;
